import React, { useEffect, useState } from "react";
import {
  DeleteAuctions,
  GetCurrentAuctionsService,
} from "../../../services/auctions.service";
import { StatusCodes } from "http-status-codes";
import { IAuctions, IAuctionsData } from "./auction.interface";
import moment from "moment";
import { AuctionTableColumns } from "./previousAuctions";
import TableLoader from "../../../components/TableLoader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const CurrentAuctions = ({
  setSelectedTab,
}: {
  setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const navigate = useNavigate();
  const [currentAuctions, setCurrentAuctions] = useState<IAuctionsData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const GetCurrentAuctions = async () => {
    setLoading(true);
    const response = await GetCurrentAuctionsService();
    if (response.status && response.status_code === StatusCodes.OK) {
      setCurrentAuctions(response.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    GetCurrentAuctions();
  }, []);

  const handleDeleteAuctions = async (auction_id: number) => {
    if (window.confirm("Are you sure you want to delete?")) {
      const response = await DeleteAuctions(auction_id);
      if (response.status && response.status_code === StatusCodes.OK) {
        toast.success(response.message);
        await GetCurrentAuctions();
      } else {
        toast.error(response.message);
      }
    }
  };
  const handleEditAuctions = (id: any) => navigate(`/auction/${id}`);

  return loading ? (
    <TableLoader />
  ) : (
    <div>
      <h1 className="text-xl text-bold">Current Auctions</h1>
      {currentAuctions.length > 0 ? (
        <table className="mt-4 w-15">
          <thead>
            <tr>
              {AuctionTableColumns.map((column) => {
                return <th key={column.key}>{column.title}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {currentAuctions?.map((row, index) => {
              return (
                <tr key={index}>
                  <td>{moment(row.date).format("YYYY/MM/DD")}</td>
                  <td>{row.title}</td>
                  <td>
                    {row.address},{row.city},{row.state}
                  </td>
                  <td>{moment(row.created_at).format("YYYY/MM/DD")}</td>
                  <td>
                    <button
                      onClick={() => handleEditAuctions(row.id)}
                      className="border-2 px-1 border-gray-600 bg-gray-400"
                    >
                      edit
                    </button>
                    &nbsp;
                    <button
                      onClick={() => handleDeleteAuctions(row.id)}
                      className="border-2 px-1 border-gray-600 bg-gray-400"
                    >
                      delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div>No Auctions found</div>
      )}
    </div>
  );
};

export default CurrentAuctions;
